import React from 'react';
import PropTypes from 'prop-types';
import labels from '../i18n';

const NoResultsComponent = (props) => {
  const { lang, mode } = props;
  return (
    <div className="au-vacancies-no-results">
      <div className="meh-with-cap">
        <img src="https://cdn.au.dk/apps/react/vacancies/latest/meh-with-cap.svg" alt="No results" />
      </div>
      <div className="no-results" dangerouslySetInnerHTML={{ __html: mode === 'main' ? labels[lang].noResults : labels[lang].noResultsFaculty }} />
    </div>
  );
};

NoResultsComponent.propTypes = {
  lang: PropTypes.string.isRequired,
  mode: PropTypes.string.isRequired,
};

NoResultsComponent.displayName = 'NoResultsComponent';
export default NoResultsComponent;
